<template>
  <div class="container">
    <div class="customersFeedbackBlock">
      <p class="title">
        {{ $t('customersFeedback') }}
      </p>
      <div class="container">
        <div v-for="(el, index) in sortedData" :key="index" class="comment">
          <img
            v-if="el.type !== 'notRated'"
            :src="
              require(`@/assets/icons/${getLabel(el.type)[el.type]}Pressed.png`)
            "
            alt=""
          />
          <p>{{ el.value }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

type FeedbackItem = {
  timestamp: number;
  value: string;
};

@Options({
  name: 'CustomersFeedbackBlock',
  props: ['data'],
  computed: {
    sortedData() {
      if (!this.data) return [];

      const merged = Object.entries(this.data).flatMap(([key, arr]) =>
        (arr as FeedbackItem[]).map((item) => ({ ...item, type: key }))
      );

      return merged.sort((a, b) => a.timestamp - b.timestamp);
    }
  },
  methods: {
    getLabel(type: string) {
      if (type !== 'notRated') {
        const labelsMap: Record<string, unknown> = {
          GOOD: 'Happy',
          OK: 'Ok',
          BAD: 'Angry'
        };

        return labelsMap;
      }
    }
  }
})
export default class CustomersFeedbackBlock extends Vue {}
</script>

<style lang="scss" scoped>
.container {
  .customersFeedbackBlock {
    max-width: 1140px;
    width: 100%;
    max-height: 545px;
    height: 100%;
    border: 1px solid $border;
    border-radius: 8px;
    padding: 20px;
    margin: 24px;
    overflow: auto;
    p {
      color: $lineColor;
      padding-bottom: 32px;
    }
    .container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
      .comment {
        height: max-content;
        display: flex;
        align-items: center;
        gap: 12px;
        border: 1px solid $border;
        padding: 12px;
        border-radius: 4px;
        font-size: 15px;
        img {
          width: 35px;
          height: 40px;
          margin-right: 20px;
        }
        p {
          padding-bottom: 0;
        }
      }
    }
  }
}
</style>
